// hsa1 === home section about title
const hsat1 = gsap.timeline({ paused: true });
hsat1.fromTo('.home-about-content-header .sec-header-content-anim-line', {
    x: 0,
    y: 49,
    z: -41,
    rotationX: -80,
    transformOrigin: '50% 0%',
    opacity: 0,
},
{
    x: 0,
    y: 0,
    z: 0,
    rotationX: 0,
    transformOrigin: '318px 30px',
    opacity: 1,
    stagger: 0.05,
    duration: 0.9,
    ease: 'power4.out'
})
ScrollTrigger.create({
    trigger: ".home-about-content-header",
    start: '0% 80%',
    // markers: true,
    onEnter: () => hsat1.play(),
    onLeaveBack: () => hsat1.reverse()
})

ScrollTrigger.create({
    trigger: ".home-about-img-block .home-about-content-header",
    start: '0% 80%',
    // markers: true,
    onEnter: () => hsat1.play(),
    onLeaveBack: () => hsat1.reverse()
})

new SplitType('.home-about-content-des p', {
    types: 'lines',
    lineClass: "about-content-des-lines",
    tagName: "span"
})

const hsad1 = gsap.timeline({ paused: true });
hsad1.fromTo('.about-content-des-lines', {
    x: 0,
    y: 50,
    z: -42,
    rotationX: -80,
    transformOrigin: '50% 0%',
    opacity: 0,
}, {
    x: 0,
    y: 0,
    z: 0,
    rotationX: 0,
    transformOrigin: '205px 13px',
    opacity: 1,
    stagger: 0.05,
    duration: 0.9,
    ease: 'power4.out'
})
ScrollTrigger.create({
    trigger: ".home-about-content-des",
    start: '0% 70%',
    // end: '100% 70%',
    // markers: true,
    onEnter: () => hsad1.play(),
    onLeaveBack: () => hsad1.reverse()
})

const hsac1 = gsap.timeline({ paused: true });
hsac1.fromTo('.home-about-content-cta .contact-cta-wrappr', {
    y: -30,
}, {
    y: 0,
    stagger: 0.05,
    duration: 1,
    ease: "bounce.out",

})
ScrollTrigger.create({
    trigger: ".home-about-content-cta",
    start: '0% 70%',
    // end: '100% 70%',
    // markers: true,
    onEnter: () => hsac1.play(),
    onLeaveBack: () => hsac1.reverse()
})

// image anim start-------------
const parallaximage = document.querySelectorAll('.img-block-img');
parallaximage.forEach(function (imgeMove) {
    gsap.set(imgeMove, {
        scale: 1.2,
    })
    const imageRect = imgeMove.getBoundingClientRect();
    const heightDifference = imageRect.height - imgeMove.parentElement.offsetHeight;
    gsap.fromTo(imgeMove, {
        y: -heightDifference,
    },
        {
            scrollTrigger: {
                trigger: imgeMove,
                start: 'top center+=30%',
                end: 'bottom+=10% top',
                scrub: true,
                // markers: true,
            },
            y: heightDifference,
            ease: 'none',
        })
})

// hah == home about header color
const hah = gsap.timeline({
    scrollTrigger: {
        trigger: '.home-about',
        start: "-10% 40%",
        end: "100% 60%",
        scrub: true,
        // markers: true,
    }
})
hah.to('.header-bg', {
    backgroundColor: 'rgb(40, 88, 209)',
}, 'hsa')
hah.to('.header-contact-cta-link a', {
    backgroundColor: 'rgb(21, 23, 30)',
}, 'hsa')